import React, { useState } from 'react';
import { LuChevronLeft as ChevronLeft } from 'react-icons/lu';

import LensFollowTab from './LensFollowTab';
import LensRecommendTab from './LensRecommendTab';

/**
 * 상세 탭 껍데기
 * - 신규 등록도 이 화면에서 처리한다(recordMode="new").
 * - 팔로우 탭은 최초 데이터가 저장된 뒤에만 사용할 수 있다.
 * - case_id 단위로 최초/팔로우 이력을 묶는다.
 */
export default function LensRecommendDetailFrame({
  chartNo: initialChartNo = '',
  eye: initialEye = 'OD',
  caseId: initialCaseId = '',
  seedRow = null,
  recordMode = 'existing',
  initialTab = 'recommend',
  recommendSnapshot = null,
  onBack,
  onSavedFirst
}) {
  const isNew = recordMode === 'new';
  const [tab, setTab] = useState(initialTab);
  const [latestRecommend, setLatestRecommend] = useState(recommendSnapshot);
  const [saved, setSaved] = useState(!isNew);
  const [chartNo, setChartNo] = useState(initialChartNo);
  const [eye, setEye] = useState(initialEye);
  const [caseId, setCaseId] = useState(
    initialCaseId
    || seedRow?.caseId
    || seedRow?.case_id
    || ''
  );

  const followEnabled = saved && Boolean(chartNo) && Boolean(caseId);

  return (
    <div className="lens-page">
      <header className="lens-header">
        <div>
          <h1 className="lens-title">ICL Vault AI</h1>
          <p className="lens-subtitle">{saved ? '상세 · 렌즈추천 / 경과관찰' : '새 렌즈 추천'}</p>
        </div>
      </header>

      <div className="lens-v2-detail-header">
        <nav className="lens-v2-breadcrumb" aria-label="위치">
          <button className="lens-v2-breadcrumb-link" type="button" onClick={onBack}>
            <ChevronLeft size={15} />
            목록
          </button>
          <span className="lens-v2-breadcrumb-sep" aria-hidden="true">/</span>
          <span className="lens-v2-breadcrumb-current" aria-current="page">
            {saved ? '상세' : '신규 등록'}
          </span>
        </nav>
      </div>

      <div className="lens-v2-tabs">
        <button
          type="button"
          className={`lens-v2-tab${tab === 'recommend' ? ' lens-v2-tab-active' : ''}`}
          onClick={() => setTab('recommend')}
        >
          렌즈추천
        </button>
        <button
          type="button"
          className={`lens-v2-tab${tab === 'follow' ? ' lens-v2-tab-active' : ''}`}
          onClick={() => followEnabled && setTab('follow')}
          disabled={!followEnabled}
          title={followEnabled ? undefined : '렌즈추천을 저장한 뒤 입력할 수 있습니다.'}
        >
          경과관찰
        </button>
      </div>

      {tab === 'recommend' || !followEnabled ? (
        <LensRecommendTab
          recordMode={saved ? 'existing' : 'new'}
          chartNo={chartNo}
          eye={eye}
          caseId={caseId}
          seedRow={saved ? null : seedRow}
          onSaved={({ chartNo: savedChartNo, eye: savedEye, caseId: savedCaseId, result }) => {
            setLatestRecommend(result);
            setChartNo(savedChartNo);
            setEye(savedEye);
            if (savedCaseId) setCaseId(savedCaseId);
            if (!saved) {
              setSaved(true);
              onSavedFirst?.({
                chartNo: savedChartNo,
                eye: savedEye,
                caseId: savedCaseId
              });
            }
          }}
        />
      ) : (
        <LensFollowTab
          chartNo={chartNo}
          eye={eye}
          caseId={caseId}
          recommendSnapshot={latestRecommend}
        />
      )}
    </div>
  );
}
